import { render, staticRenderFns } from "./otp.vue?vue&type=template&id=0de5af3e&scoped=true"
import script from "./otp.vue?vue&type=script&lang=js"
export * from "./otp.vue?vue&type=script&lang=js"
import style0 from "./otp.vue?vue&type=style&index=0&id=0de5af3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de5af3e",
  null
  
)

export default component.exports